import {workplaceTypes} from "../types";
import { isEnabledMsg, isUnreadMsg, transformDate } from "@/utils.js";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { user } from '@/components/User'
import { interval } from '@/components/Interval.js';
import { storage } from "../components/Storage";


export var MessagePage  = {
    errCheckList: null,
    unread: true,
    readIt: function (readed) {
        if(this.unread && readed == null) {
            this.unread = false;
            return false;
        }
        else
            return true;
    },
    controller: function () {
        var self = this;
        self.errCheckList = "";

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();
        this.unread = true;

        if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Техника', url: '/vehicle', icon: 'fa-truck' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];

            if (user.get('state.vehicleFreeTasksAvailable')) {
                this.topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else if (user.get('state.workplace') === workplaceTypes.agent) {
            this.topMenu = [
                { title: 'Задачи', url: '/agent/tasks', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        } else {
            this.topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        };
        let user_data = JSON.parse(localStorage.getItem('user'));
        const config = storage.config;
        if(config["message_service"] !== 'undefined') {
            this.data = m.request({
                method: 'POST',
                url: "/api/getMessage",
                data: {'receiver': user_data.id, 'service_addr': config["message_service"]}
            }).then(function (response) {
                if(response[0]["code"] != undefined) {
                    if(response[0]["code"] == 1) {
                        let output = [];
                        output['none'] = "empty";
                        return output;
                    }
                }

                const readMessage = [];
                const unreadMessage = [];
                if (response.length) {
                    response.map(function (el) {
                        if (el.readed)
                            readMessage.push(el)
                        else
                            unreadMessage.push(el);
                    });
                }
                readMessage.sort(function (a, b) {
                    if (a.sended > b.sended) {
                        return 1;
                    } else if (a.sended < b.sended) {
                        return -1;
                    }
                    return 0;
                });
                unreadMessage.sort(function (a, b) {
                    if (a.sended > b.sended) {
                        return 1;
                    } else if (a.sended < b.sended) {
                        return -1;
                    }
                    return 0;
                });
                const output = [];
                output['readMessage'] = readMessage;
                output['unreadMessage'] = unreadMessage;
                output['none'] = null;

                setTimeout(() => {
                    let el = document.getElementById('unread');
                    if (el !== null)
                        el.scrollIntoView({block: "center", inline: "center", behavior: "smooth"});
                    else {
                        document.getElementById('endList').scrollIntoView({
                            block: "center",
                            inline: "center",
                            behavior: "smooth"
                        });
                    }
                }, 1500);

                return output;
            }, function (response) {
                const output = [];
                output['none'] = "service_connect_error";
                return output;
            });

        } else {
            let output = [];
            output['readMessage'] = [];
            output['unreadMessage'] = [];
            output['none'] = null;
            return output;
        }
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                //time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[id='messageWindow'][style='padding:7px;margin-top:80px']", {
                    onclick() {
                        var list = document.querySelectorAll(".message-unread");
                        var msg = localStorage.getItem("messages");
                        if(msg) {
                            var msg_arr = JSON.parse(msg);
                            for(let i=0; i<msg_arr.length; i++) {
                                if(msg_arr[i].readed == null)
                                    msg_arr[i].readed = "readed";
                            }
                            localStorage.setItem("messages", JSON.stringify(msg_arr));
                        }
                        let el = document.querySelector(".fa-envelope-o");
                        if(el) {
                            el.classList.remove("fa-envelope-o");
                            el.classList.add("fa-envelope-open-o");
                        }
                        const config = storage.config;
                        if(config["message_service"] !== 'undefined') {
                            if (list.length) {
                                list.forEach(el => {
                                    el.classList.remove("message-unread");
                                    m.request({
                                        method: 'POST',
                                        url: '/api/readMessage',
                                        data: {'messageid': el.id, 'service_addr': config["message_service"]}
                                    }).then(function (response) {
                                    });
                                });
                            }
                        }
                    },
                    ontouchend: function () {
                        var list = document.querySelectorAll(".message-unread");
                        const config = storage.config;
                        if(config["message_service"] !== 'undefined') {
                            if (list.length) {
                                list.forEach(el => {
                                    el.classList.remove("message-unread");
                                    m.request({
                                        method: 'POST',
                                        url: '/api/readMessage',
                                        data: {'messageid': el.id, 'service_addr': config["message_service"]}
                                    }).then(function (response) {
                                    });
                                });
                            }
                        }
                    },
                },
                [
                    m(".container[id='container'][href='#unread']", [
                        ctrl.data().none != null ?
                            (ctrl.data().none == "empty" ? m(".row[style='text-align: center; margin-top: 10px; font-style: italic; font-size: 16px']", "Нет сообщений") :
                                m(".row[style='text-align: center; margin-top: 10px; font-style: italic; font-size: 16px']", "Ошибка подключения к службе сообщений") ) : [
                                ctrl.data().readMessage.map(function (el) {
                                    return m(".row.message-aria", {
                                        class: el.readed ? "" : "message-unread"
                                    }, [
                                        m("div[style='text-align: left; font-size: 12px; font-style: italic;']", el.sender + ", диспетчер"),
                                        m("div[style='text-align: right; margin: 7px 0px']", el.text),
                                        m("div[style=overflow: hidden]", [
                                            m("div[style=width: 100%; font-size: 12px; font-style: italic;]", [
                                                m("div[style=float: left; ]", transformDate(el.sended, 'date')),
                                                m("div[style=float: right; ]", transformDate(el.sended, 'time'))
                                            ])
                                        ])
                                    ])
                                }),
                                ctrl.data().unreadMessage.length ? m(".row[id='unread'][autofocus][style='text-align: center; margin-top: 10px; background-color: #e6e6e6']", "Непрочитанные собщения") : [],
                                ctrl.data().unreadMessage.map(function (el) {
                                    return m(".row.message-aria", {
                                        class: el.readed ? "" : "message-unread",
                                        id: el.id
                                    }, [
                                        m("div[style='text-align: left; font-size: 12px; font-style: italic;']", el.sender + ", диспетчер"),
                                        m("div[style='text-align: right; margin: 7px 0px']", el.text),
                                        m("div[style=overflow: hidden]", [
                                            m("div[style=width: 100%; font-size: 12px; font-style: italic;]", [
                                                m("div[style=float: left; ]", transformDate(el.sended, 'date')),
                                                m("div[style=float: right; ]", transformDate(el.sended, 'time'))
                                            ])
                                        ])
                                    ])
                                })
                            ],
                        m(".row[id='endList']", {
                            style: "height: 180px"
                        }),
                    ])
                ],
            )
        ];
    }
}
